<template>
  <div>
    <!--Rows -->
    <div v-if="!onlyMinutaAndSignPei">
      <ValidationObserver ref="observer" name="participants" tag="form">
        <div class="participant-signatures border-radius--light">
          <div
            v-for="(item, index) in participantsRequireSignature"
            :key="index"
          >
            <ParticipantSignaturesRow
              v-model="item.model"
              :key="componentKey"
              :original-signature-type-id="item.originalSignatureTypeId"
              :original-email="item.originalEmail"
              :positionName="item.positionName"
              :positionCode="item.positionCode"
              :fullName="item.fullName"
              :validate="validate"
              :schoolId="schoolId"
              ref="signatureRow"
              class="participant"
              :signature-types="signatureTypes"
              :show-option="showOptionDigitalSignature"
              :all-signatures-must-be-electronic="
                !allTypesAreElectronic && showTypeError(item.model)
              "
              :atLeastOneIsElectronic="atLeastOneIsElectronic"
              :disabled="index != 0"
              @update-signature-type="handleUpdateSignatureType"
            />
          </div>
        </div>
      </ValidationObserver>
    </div>
    <SectionTitle
      v-if="participantsWithoutSignature?.length"
      icon="fas fa-user-edit"
      content="Participantes que no requieren firma"
      container-class="mt-4 mb-2"
      reverse
    />
    <div class="participant-signatures bg-secondary-3 border-radius--light">
      <div
        v-for="(participant, index) in participantsWithoutSignature"
        :key="index"
      >
        <Tab10ParticipantWithoutSignaturesRow
          ref="ParticipantRow"
          :participant="participant"
          :pei-document-alternate-participation-date="
            peiDocumentAlternateParticipationDate
          "
          class="participant"
          @document="setDocuments"
        />
      </div>
    </div>

    <AtServiceDocumentsManager
      v-if="atServiceDocuments.length > 0"
      v-model="atServiceDocuments"
      :is-disabled="isSignedPei"
      @input="$emit('at-service-documents', $event)"
      @refresh="fetchAtServiceDocuments"
    />
    <div v-else-if="isSignedPeiParameterEnable">
      <SectionTitle
        icon="fas fa-file"
        content="Minuta COMPU"
        container-class="mt-4 mb-2"
        reverse
      />
      <CompuMinuteSelection
        v-if="isCompuMinuteSystemSelectionEnabled"
        :value="compuMinutes"
        :student-sie-id="studentSieId"
        :disabled="isSignedPei"
        :on-go-to-draft-minute="goToDraftMinute"
        @input="compuMinutes = { ...compuMinutes, ...$event }"
        @delete="deleteCompuMinuteSignFile"
      />
      <div
        v-if="
          enableCompuReplacement ||
            !isCompuMinuteSystemSelectionEnabled ||
            compuMinutes.useSystemMinute === false
        "
        class="p-4 bg-secondary-3 border-radius--light"
      >
        <template>
          <CustomFileInput
            id="compuMinutes"
            ref="compuMinutes"
            :key="compuMinutesKey"
            v-model="compuMinutes.file"
            :can-delete="isPeiStatusCompleted && compuMinutes.fileId != null"
            :is-replacing="enableCompuReplacement"
            display-style="normal"
            :accept="'.pdf'"
            :max-size="inputFileMaxSizeInMB"
            :disabled="compuMinutes.fileId != null && !enableCompuReplacement"
            :attachment-id="compuMinutes.fileId"
            :name="compuMinutes.fileName"
            custom-error-msg="El documento es requerido."
            @input="handleCompuChange"
            @delete="
              (documentId) =>
                deleteSignDocument(documentId, DOCUMENT_TYPE.CompuMinutes)
            "
          />

          <div
            class="replacement-action__container"
            v-if="
              compuMinutes.fileId != null &&
                hasReplacementFileInSignedPeiPermission
            "
          >
            <ActionButton
              v-if="!this.enableCompuReplacement"
              variant="success"
              @click="enableDocumentReplacement(DOCUMENT_TYPE.CompuMinutes)"
            >
              Reemplazar Documento
            </ActionButton>
            <div v-else>
              <ActionButton
                variant="success"
                class="mr-2"
                :disabled="!compuMinutes.fileId && !compuMinutes.file"
                @click="replaceSignDocuments(DOCUMENT_TYPE.CompuMinutes)"
              >
                Guardar
              </ActionButton>
              <ActionButton
                variant="outline-danger"
                @click="cancelDocumentsReplacement(DOCUMENT_TYPE.CompuMinutes)"
              >
                Cancelar
              </ActionButton>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-if="isSignedPeiParameterEnable">
      <div
        v-if="
          signedPei.fileId != null ||
            (!isDigitalSignatureIncomplete &&
              (isDigitalSignatureCancelled ||
                !hasValidDigitalSignatureDocument))
        "
      >
        <SectionTitle
          icon="fas fa-file"
          content="PEI Firmado"
          container-class="mt-4 mb-2"
          reverse
        />
        <div class="p-4 bg-secondary-3 border-radius--light">
          <CustomFileInput
            id="signedPei"
            ref="signedPei"
            :key="signedPeiKey"
            v-model="signedPei.file"
            display-style="normal"
            :can-delete="enableSignedPeiReplacement && canRemoveSignPeiDocument"
            :is-replacing="enableSignedPeiReplacement"
            :accept="'.pdf'"
            :max-size="inputFileMaxSizeInMB"
            :disabled="signedPei.fileId != null && !enableSignedPeiReplacement"
            :attachment-id="signedPei.fileId"
            :name="signedPei.fileName"
            custom-error-msg="El documento es requerido."
            @input="handleSignedPeiChange"
            @delete="
              (documentId) =>
                deleteSignDocument(documentId, DOCUMENT_TYPE.SignedPei)
            "
          />
          <div
            class="replacement-action__container"
            v-if="
              hasReplacementFileInSignedPeiPermission &&
                (signedPei.fileId != null || enableSignedPeiReplacement)
            "
          >
            <ActionButton
              v-if="!this.enableSignedPeiReplacement"
              variant="success"
              @click="enableDocumentReplacement(DOCUMENT_TYPE.SignedPei)"
            >
              Reemplazar Documento
            </ActionButton>
            <div v-else>
              <ActionButton
                variant="success"
                class="mr-2"
                :disabled="!signedPei.fileId && !signedPei.file"
                @click="replaceSignDocuments(DOCUMENT_TYPE.SignedPei)"
              >
                Guardar
              </ActionButton>
              <ActionButton
                variant="outline-danger"
                @click="cancelDocumentsReplacement(DOCUMENT_TYPE.SignedPei)"
              >
                Cancelar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <SectionTitle
          icon="fas fa-file"
          content="PEI Firmado"
          container-class="mt-4 mb-2"
          reverse
        />
        <CustomFileInput
          v-if="
            !isDigitalSignatureIncomplete && hasValidDigitalSignatureDocument
          "
          id="signedSaee10"
          ref="signedSaee10"
          display-style="normal"
          :can-delete="canRemoveSignPeiDocument"
          :accept="'.pdf'"
          :isDigitalSignature="true"
          :attachment-id="documentDigital.documentId"
          :name="
            (documentDigital.documentTitle || 'Documento firmado') + '.pdf'
          "
        />
        <Error
          v-else
          is-alert-mode
          message="Le informamos que la sección de PEI Firmado no estará visible temporalmente, ya que actualmente hay un documento en proceso de firma. Una vez que el proceso de firma se haya completado, la sección volverá a estar disponible con el documento anejado con todas sus firmas."
        />
      </div>
    </div>

    <div
      v-if="
        isSignedPeiParameterEnable &&
          isSaee10ValidNeeds &&
          isUploadSaee10Required
      "
    >
      <SectionTitle
        icon="fas fa-file"
        content="Consulta Anejo 01 sobre necesidad de Asistente de Servicio Firmada"
        container-class="mt-4 mb-2"
        reverse
      />
      <div class="p-4 bg-secondary-3 border-radius--light">
        <CustomFileInput
          id="signedSaee10"
          ref="signedSaee10"
          :key="saee10Key"
          v-model="signedSaee10.file"
          display-style="normal"
          :accept="'.pdf'"
          :disabled="isSignedPei && !enableSaee10Replacement"
          :attachment-id="signedSaee10.fileId"
          :name="signedSaee10.fileName"
          custom-error-msg="El documento es requerido."
          @input="handleSignedSaee10Change"
        />
        <div
          class="replacement-action__container"
          v-if="
            hasReplacementFileInSignedPeiPermission &&
              (isSignedPei || enableSaee10Replacement)
          "
        >
          <ActionButton
            v-if="!this.enableSaee10Replacement"
            variant="success"
            @click="enableDocumentReplacement(DOCUMENT_TYPE.SignedSaee10)"
          >
            Reemplazar Documento
          </ActionButton>
          <div v-else>
            <ActionButton
              variant="success"
              class="mr-2"
              :disabled="
                signedSaee10.fileId ||
                  (!signedSaee10.fileId && !signedSaee10.file)
              "
              @click="replaceSignDocuments(DOCUMENT_TYPE.SignedSaee10)"
            >
              Guardar
            </ActionButton>
            <ActionButton
              variant="outline-danger"
              @click="cancelDocumentsReplacement(DOCUMENT_TYPE.SignedSaee10)"
            >
              Cancelar
            </ActionButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import SectionTitle from 'SectionTitle';
import CustomFileInput from '@/components/common/CustomFileInput';
import CompuMinuteSelection from '@/components/shared/CompuMinuteSelection.vue';
import generalService from '@/services/pei/general';
import compuMinuteService from '@/modules/compu-minutes-editor/api';
import { ValidationObserver } from 'vee-validate';
import { documentStatuses } from '@/utils/constants/signature/statusDocumentSignature';
import { SignatureTypes } from '@/utils/constants/signature/signatureTypes';
import ParticipantSignaturesRow from '@/components/pei/tabs/components/tab10/Tab10ParticipantSignaturesRow';
import Tab10ParticipantWithoutSignaturesRow from '@/components/pei/tabs/components/tab10/Tab10ParticipantWithoutSignaturesRow';
import { mapGetters } from 'vuex';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import store from '@/store/index';
import peiCode from '@/utils/constants/pei/peiCode';
import mixAlert from '@/mixin/alert.mixin';
import PermissionsNames from '@/utils/constants/permissions.js';
import Error from '@/components/common/Error.vue';
import signatures from '@/services/signatures';
import AtServiceDocumentsManager from './AtServiceDocumentsManager.vue';
import { AtServiceDocumentTypes } from './AtServiceDocumentEnum';

const fileMaxSizeInMB = 20;

export default {
  name: 'Tab10ParticipantSignatures',
  mixins: [mixAlert],
  components: {
    Error,
    SectionTitle,
    ActionButton,
    CustomFileInput,
    ValidationObserver,
    ParticipantSignaturesRow: ParticipantSignaturesRow,
    Tab10ParticipantWithoutSignaturesRow,
    AtServiceDocumentsManager,
    CompuMinuteSelection,
  },
  props: {
    signatureFiles: {
      type: Object,
      default: () => ({
        compuMinutes: {
          fileId: null,
          fileName: null,
          file: null,
          compuMinuteId: null,
        },
        signedPei: {
          fileId: null,
          fileName: null,
          file: null,
        },
        signedSaee10: {
          fileId: null,
          fileName: null,
          file: null,
        },
      }),
    },
    documentDigital: {
      type: Object,
      default: () => {},
    },
    listOfSignatures: {
      type: Array,
      default: () => [],
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    signatureTypes: {
      type: Array,
      default: () => [],
    },
    infoMessage: {
      type: String,
      default: '',
    },
    onlyMinutaAndSignPei: {
      type: Boolean,
      default: false,
    },
    showOptionDigitalSignature: {
      type: Boolean,
      default: false,
    },
    allTypesAreElectronic: {
      type: Boolean,
      default: false,
    },
    atLeastOneIsElectronic: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      atServiceDocuments: [],
      compuMinutes: {
        ...this.signatureFiles.compuMinutes,
        useSystemMinute: this.signatureFiles.compuMinutes?.compuMinuteId
          ? true
          : this.signatureFiles.compuMinutes?.fileId
          ? false
          : null,
      },
      signedPei: { ...this.signatureFiles.signedPei },
      signedSaee10: { ...this.signatureFiles.signedSaee10 },
      documentList: [],
      sysParameters: [],
      listOfSignaturesData: this.listOfSignatures,
      componentKey: 0,
      compuMinutesKey: 0,
      enableCompuReplacement: false,
      signedPeiKey: 0,
      enableSignedPeiReplacement: false,
      saee10Key: 0,
      enableSaee10Replacement: false,
      selectedPeiNeeds: [],
      DOCUMENT_TYPE: {
        CompuMinutes: 1,
        SignedPei: 2,
        SignedSaee10: 3,
      },
      isElectronic: false,
      schoolId: null,
      studentSieId: null,
    };
  },
  watch: {
    'signatureFiles.compuMinutes'(newVal) {
      const hasNoLocalData =
        !this.compuMinutes.compuMinuteId &&
        !this.compuMinutes.fileId &&
        this.compuMinutes.useSystemMinute === null;
      if (hasNoLocalData && (newVal?.compuMinuteId || newVal?.fileId)) {
        this.compuMinutes = {
          ...newVal,
          useSystemMinute: newVal?.compuMinuteId
            ? true
            : newVal?.fileId
            ? false
            : null,
        };
      }
    },
  },
  async mounted() {
    await this.fetchAtServiceDocuments();
    const { data: sysParameters } = await getSysparameterByNames({
      parameterNames: [
        'IsEnablePeiSignatureCompuFiles',
        'IsEnablePeiSignaturePeiSignedFiles',
      ],
      academicYearId: store.getters.getConfigAcademicYearId,
    });
    this.sysParameters = sysParameters;

    const { data } = await getSysparameterByNames({
      parameterNames: [
        'PEIDocumentAlternateParticipation',
        'PEIDocumentSAEE10',
        'ActiveCompuMinuteSystemSelection',
      ],
    });

    this.sysParameters = [...this.sysParameters, ...data];

    await this.loadSelectedPeiNeeds();
    this.setIfIsElectronic();
    const info = await generalService.getPei(this.selectedPei);
    this.schoolId = info.data.schoolId;
    this.studentSieId = info.data.studentSieId;
  },
  methods: {
    async fetchAtServiceDocuments() {
      const atServiceDocuments = await signatures.getAtServiceDocuments(
        this.selectedPei
      );
      this.atServiceDocuments = [...atServiceDocuments.data];
    },
    enableDocumentReplacement(docType) {
      switch (docType) {
        case this.DOCUMENT_TYPE.CompuMinutes:
          this.enableCompuReplacement = true;
          break;
        case this.DOCUMENT_TYPE.SignedPei:
          this.enableSignedPeiReplacement = true;
          break;
        case this.DOCUMENT_TYPE.SignedSaee10:
          this.enableSaee10Replacement = true;
          break;
      }
    },
    async goToDraftMinute() {
      const response = await compuMinuteService
        .createDraftFromPei({
          studentSieId: this.studentSieId,
          peiId: this.selectedPei,
        })
        .catch((err) => {
          this.ShowToast(
            'Error',
            err?.response?.data?.message ||
              'No fue posible crear la minuta de COMPU.',
            'error'
          );
        });

      const id = response?.data?.id ?? response?.data;
      if (!id) return;

      this.$router.push(`/pei/compu-minutes-editor/${id}`);
    },
    async deleteCompuMinuteSignFile() {
      const peiId = this.selectedPei;
      const file = { ...this.compuMinutes };
      this.compuMinutes = {};
      await generalService.deleteCompuMinuteDocument(peiId).catch(() => {
        this.compuMinutes = file;
      });
    },
    async deleteSignDocument(documentId, docType) {
      const peiId = this.selectedPei;
      let file = null;
      switch (docType) {
        case this.DOCUMENT_TYPE.CompuMinutes:
          file = { ...this.compuMinutes };
          this.compuMinutes = {};
          await generalService
            .deletePeiSignatureDocument(peiId, documentId)
            .catch(() => {
              this.compuMinutes = file; // rollback
            });
          break;
        case this.DOCUMENT_TYPE.SignedPei:
          file = { ...this.signedPei };
          this.signedPei = {};
          await generalService
            .deletePeiSignatureDocument(peiId, documentId)
            .catch(() => {
              this.signedPei = file; // rollback
            });
          break;
      }
    },
    cancelDocumentsReplacement(docType) {
      switch (docType) {
        case this.DOCUMENT_TYPE.CompuMinutes:
          this.enableCompuReplacement = false;
          this.compuMinutes = { ...this.signatureFiles.compuMinutes };
          this.compuMinutesKey += 1;
          break;
        case this.DOCUMENT_TYPE.SignedPei:
          this.enableSignedPeiReplacement = false;
          this.signedPei = { ...this.signatureFiles.signedPei };
          this.signedPeiKey += 1;
          break;
        case this.DOCUMENT_TYPE.SignedSaee10:
          this.enableSaee10Replacement = false;
          this.signedSaee10 = { ...this.signatureFiles.signedSaee10 };
          this.saee10Key += 1;
          break;
      }
    },
    async replaceSignDocuments(docType) {
      let isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        '¿Esta seguro que desea reemplazar el documento?',
        'Si',
        'No'
      );

      if (!isConfirmed) return;

      const formData = new FormData();
      formData.append(
        'compuMinutes.fileId',
        this.signatureFiles.compuMinutes.fileId ?? ''
      );
      formData.append(
        'signedPei.fileId',
        this.signatureFiles.signedPei.fileId ?? ''
      );
      formData.append(
        'signedSaee10.fileId',
        this.signatureFiles.signedSaee10.fileId ?? ''
      );

      switch (docType) {
        case this.DOCUMENT_TYPE.CompuMinutes:
          formData.append('compuMinutes.fileId', '');
          formData.append('compuMinutes.file', this.compuMinutes.file);
          break;
        case this.DOCUMENT_TYPE.SignedPei:
          formData.append('signedPei.fileId', '');
          formData.append('signedPei.file', this.signedPei.file);
          break;
        case this.DOCUMENT_TYPE.SignedSaee10:
          formData.append('signedSaee10.fileId', '');
          formData.append('signedSaee10.file', this.signedSaee10.file);
          break;
      }

      await generalService.uploadSignDocuments(
        this.$store.state.peiSelected,
        formData
      );
      this.$emit('refreshdocuments');

      switch (docType) {
        case this.DOCUMENT_TYPE.CompuMinutes:
          this.enableCompuReplacement = false;
          break;
        case this.DOCUMENT_TYPE.SignedPei:
          this.enableSignedPeiReplacement = false;
          break;
        case this.DOCUMENT_TYPE.SignedSaee10:
          this.enableSaee10Replacement = false;
          break;
      }
    },
    handleSignedPeiChange(data) {
      if (data) return;

      this.signedPei.fileId = null;
    },
    handleCompuChange(data) {
      if (data) return;

      this.compuMinutes.fileId = null;
    },
    handleSignedSaee10Change(data) {
      if (data) return;

      this.signedSaee10.fileId = null;
    },
    async upsertSignFiles(peiId) {
      const formData = new FormData();
      formData.append('compuMinutes.file', this.compuMinutes.file);
      formData.append('compuMinutes.fileId', this.compuMinutes.fileId ?? '');
      formData.append(
        'compuMinutes.compuMinuteId',
        this.compuMinutes.compuMinuteId ?? ''
      );

      formData.append('signedPei.file', this.signedPei.file);
      formData.append('signedPei.fileId', this.signedPei.fileId ?? '');

      formData.append('signedSaee10.file', this.signedSaee10.file);
      formData.append('signedSaee10.fileId', this.signedSaee10.fileId ?? '');

      //At Service
      const discussion = this.atServiceDocuments.find(
        (x) =>
          x.documentTypeId == AtServiceDocumentTypes.EvaluationDiscussionSigned
      );
      if (discussion) {
        formData.append('atServiceDiscussion.file', discussion?.file ?? null);
        formData.append(
          'atServiceDiscussion.fileId',
          discussion?.documentId ?? ''
        );
      }

      const delivered = this.atServiceDocuments.find(
        (x) => x.documentTypeId == AtServiceDocumentTypes.DeliveredMinute
      );
      if (delivered) {
        formData.append('atServiceDelivered.file', delivered?.file ?? null);
        formData.append(
          'atServiceDelivered.fileId',
          delivered?.documentId ?? ''
        );
      }

      const estipulation80 = this.atServiceDocuments.find(
        (x) => x.documentTypeId == AtServiceDocumentTypes.Estipulation80
      );
      if (delivered) {
        formData.append(
          'atServiceEstipulation80.file',
          estipulation80?.file ?? null
        );
        formData.append(
          'atServiceEstipulation80.fileId',
          estipulation80?.documentId ?? ''
        );
      }

      await generalService.uploadSignDocuments(peiId, formData);
    },
    handleUpdateSignatureType(value) {
      for (let i = 0; i < this.listOfSignatures.length; i++) {
        this.listOfSignatures[i].model.type = value;
        this.listOfSignatures[i].model.typeId = value.id;
        if (this.listOfSignatures[i].model.typeId != SignatureTypes.email) {
          this.listOfSignatures[i].model.email = null;
        }
      }
      for (let i = 0; i < this.participantsRequireSignature; i++) {
        this.participantsRequireSignature[i].model.type = value;
        this.participantsRequireSignature[i].model.typeId = value.id;
        if (
          this.participantsRequireSignature[i].model.typeId !=
          SignatureTypes.email
        ) {
          this.participantsRequireSignature[i].model.email = null;
        }
      }
      this.$store.commit('setTab10SignatureInfo', {
        isElectronicSignature: value.id === SignatureTypes.email,
      });
      this.setIfIsElectronic();
      this.updateComponent();
    },
    validateDoc() {
      this.$refs.ParticipantRow.forEach((item) => {
        item.validate();
      });
    },
    updateComponent() {
      this.componentKey = this.componentKey == 0 ? 1 : 0;
    },
    setIfIsElectronic() {
      this.isElectronic = this.listOfSignatures.some(
        (x) => x.model?.type?.id == SignatureTypes.email
      );
    },
    setDocuments(doc) {
      const exists = this.documentList.some(
        (existingDoc) => existingDoc.idSignature === doc.idSignature
      );
      if (!exists) {
        // Si no existe, añadirlo a la lista
        this.documentList.push(doc);
      } else {
        // Si ya existe, eliminamos el existente, para evitar duplicados
        const index = this.documentList.findIndex(
          (existingDoc) => existingDoc.idSignature === doc.idSignature
        );
        this.documentList.splice(index, 1);
      }
      this.$emit('document-list', this.documentList);
    },
    isCompuFileParameterEnable() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'IsEnablePeiSignatureCompuFiles'
      );
      return obj?.staticValue.toLowerCase() === 'true' ?? false;
    },
    isDocumentSigned(val) {
      return val == documentStatuses.Signed;
    },
    async loadSelectedPeiNeeds() {
      const { data: needs } = await generalService.getSelectedPeiServiceNeed(
        this.selectedPei
      );
      this.selectedPeiNeeds = [...needs];
    },
  },
  watch: {
    signatureFiles: {
      deep: true,
      handler(newSignatureFiles) {
        if (!newSignatureFiles) return;

        if (!this.enableCompuReplacement) {
          this.compuMinutes = { ...newSignatureFiles.compuMinutes };
        }

        if (!this.enableSignedPeiReplacement) {
          this.signedPei = { ...newSignatureFiles.signedPei };
        }

        if (!this.enableSaee10Replacement) {
          this.signedSaee10 = { ...newSignatureFiles.signedSaee10 };
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      selectedPeiStatus: 'SelectedPeiStatus',
      selectedPei: 'SelectedPei',
      isDigitalSignatureCancelled: 'getIsDigitalSignatureCancelled',
    }),
    isPeiStatusCompleted() {
      return this.selectedPeiStatus == peiStatuses.Completado;
    },
    hasReplacementFileInSignedPeiPermission() {
      return store.getters.HasPermission('pei.signed.documentsreplacement');
    },
    isSignedPei() {
      return this.selectedPeiStatus == peiStatuses.Firmado;
    },
    canRemoveSignPeiDocument() {
      const statusesThatRequirePermission = [
        peiStatuses.Firmado,
        peiStatuses.PartialSignedPendingFunds,
        peiStatuses.SignedWithControversy,
        peiStatuses.CompletedWithPendingFunds,
      ].map(Number);

      if (statusesThatRequirePermission.includes(this.selectedPeiStatus)) {
        return this.hasReplacementFileInSignedPeiPermission;
      }

      return true;
    },
    isSaee10ValidNeeds() {
      return (this.selectedPeiNeeds || []).some(
        (x) =>
          x.id == peiCode.SaludConductal || x.id == peiCode.SaludAnsiedadSevera
      );
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    participantsRequireSignature: {
      get() {
        return this.listOfSignatures.filter((x) => x.requireSignature);
      },
      set(newValue) {
        this.listOfSignatures = newValue;
      },
    },
    participantsWithoutSignature() {
      return this.listOfSignatures.filter((x) => !x.requireSignature);
    },
    showTypeError() {
      return (model) => {
        const types = this.listOfSignatures.map((e) => e.model.type);
        const justOne = types.some((s) => s && s.id == SignatureTypes.email);
        if (model.type && justOne) {
          return model?.type?.id != SignatureTypes.email;
        }
        return justOne;
      };
    },
    isSignedPeiParameterEnable() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'IsEnablePeiSignaturePeiSignedFiles'
      );
      return obj?.staticValue?.toLowerCase() === 'true' ?? false;
    },
    isCompuMinuteSystemSelectionEnabled() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'ActiveCompuMinuteSystemSelection'
      );
      return obj?.staticValue?.toLowerCase() === 'true' ?? false;
    },
    peiDocumentAlternateParticipationDate() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'PEIDocumentAlternateParticipation'
      );
      return obj?.staticValue;
    },
    isUploadSaee10Required() {
      let today = new Date();
      let param = this.sysParameters.find(
        (item) => item.name === 'PEIDocumentSAEE10'
      );
      let dateParam = new Date(param?.staticValue);

      today.setHours(0, 0, 0, 0);
      dateParam.setHours(0, 0, 0, 0);

      return dateParam && today >= dateParam;
    },
    inputFileMaxSizeInMB() {
      return fileMaxSizeInMB;
    },
    isPS() {
      return this.$store.state.pei.configUnilateralFlag == '1';
    },
    canShowElectronicSignature() {
      return this.userHasPermissions(
        PermissionsNames.optionelectronicsignature
      );
    },
    isDigitalSignatureIncomplete() {
      if (this.isDigitalSignatureCancelled) return false;
      const emailSavedAndAllElectronic = this.participantsRequireSignature.every(
        (x) =>
          x.originalEmail?.length > 0 &&
          x.originalSignatureTypeId === SignatureTypes.email
      );
      return (
        emailSavedAndAllElectronic &&
        !this.isDocumentSigned(this.documentDigital?.statusId)
      );
    },
    hasValidDigitalSignatureDocument() {
      const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
      const documentId = this.documentDigital?.documentId;
      return !!documentId && documentId !== EMPTY_GUID;
    },
  },
};
</script>

<style scoped lang="scss">
.participant-signatures {
  .participant {
    padding: 1rem;
  }
  .participant:not(:first-child) {
    border-top: 2px solid gray;
  }
}

.replacement-action__container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
}
</style>
